/* =========================================================================
   Lisono — Header + Mega menu + Hamburger drawer
   Behavior only. Visual state is data-attribute-driven (see lisono-menu.css).
   ========================================================================= */
(function () {
  "use strict";

  const header   = document.querySelector("[data-lisono-header]");
  const toggles  = document.querySelectorAll("[data-lisono-toggle]");
  const drawer   = document.querySelector("[data-lisono-drawer]");
  const backdrop = document.querySelector("[data-lisono-backdrop]");

  if (!header || !toggles.length) return;

  // The header toggle is the canonical one — focus returns here on close.
  const primaryToggle = toggles[0];

  const MQ_DESKTOP = window.matchMedia("(min-width: 769px)");
  let open = false;

  function isDesktop() { return MQ_DESKTOP.matches; }

  function closeCartDrawer() {
    const cartDrawer = document.querySelector("[data-lisono-cart-drawer]");
    if (cartDrawer) cartDrawer.setAttribute("data-open", "false");
    document.documentElement.setAttribute("data-cart-open", "false");
    document
      .querySelectorAll("[data-lisono-cart-toggle]")
      .forEach((t) => t.setAttribute("aria-expanded", "false"));
  }

  function setOpen(next) {
    open = next;
    toggles.forEach((t) => t.setAttribute("aria-expanded", next ? "true" : "false"));

    if (isDesktop()) {
      header.setAttribute("data-menu-open", next ? "true" : "false");
      if (drawer) drawer.setAttribute("data-open", "false");
      document.documentElement.setAttribute("data-drawer-open", "false");
    } else {
      if (drawer) drawer.setAttribute("data-open", next ? "true" : "false");
      document.documentElement.setAttribute("data-drawer-open", next ? "true" : "false");
      header.setAttribute("data-menu-open", "false");
      if (next) trapFocus(drawer);
    }

    if (next) closeCartDrawer();
  }

  toggles.forEach((t) => t.addEventListener("click", () => setOpen(!open)));

  if (backdrop) backdrop.addEventListener("click", () => setOpen(false));

  document.addEventListener("click", (e) => {
    if (!isDesktop() || !open) return;
    if (header.contains(e.target)) return;
    setOpen(false);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && open) {
      setOpen(false);
      primaryToggle.focus();
    }
  });

  MQ_DESKTOP.addEventListener("change", () => setOpen(false));

  function trapFocus(scope) {
    if (!scope) return;
    const focusables = scope.querySelectorAll(
      'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];
    first.focus();

    scope.addEventListener("keydown", function onKey(e) {
      if (e.key !== "Tab") return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
  }
})();
